export * from './componentsProps';
export var EImageSizeType;
(function (EImageSizeType) {
  EImageSizeType[EImageSizeType["NONE"] = 0] = "NONE";
  EImageSizeType[EImageSizeType["S"] = 1] = "S";
  EImageSizeType[EImageSizeType["L"] = 2] = "L";
})(EImageSizeType || (EImageSizeType = {}));